module.exports = __webpack_public_path__ + "img/sub_page_communication21.c42d2f3f.png";